export default "__VITE_ASSET__Ce_ccTBx__"